// removed by extract-text-webpack-plugin
module.exports = {"iot":"src-components-Page----ApplicationIot-module---iot---3mdo7","btnwrappre":"src-components-Page----ApplicationIot-module---btnwrappre---qEAAd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/ApplicationIot.module.scss
// module id = 422
// module chunks = 146230036245944